import {useParams} from 'react-router-dom';
import {ContentSubmissionsMetaItem} from '@/api/fetchers/campaignContentSubmission';
import useContentSubmissionLink from '@/hooks/use-content-submission-link';
import useContentSubmissionsMeta from '@/hooks/use-content-submissions-meta';

function useContentSubmissionNavigation() {
  const {parentContentSubmissionId, contentSubmissionId} = useParams<{
    parentContentSubmissionId: string;
    contentSubmissionId: string;
  }>();
  const isStoryView = !!parentContentSubmissionId && !contentSubmissionId;
  const {dataSource, current, total} = useContentSubmissionsMeta();
  const getLink = useContentSubmissionLink();

  const buildLink = (direction: 'previous' | 'next'): string => {
    const currentIndex = current - 1;

    function getParentId(item: ContentSubmissionsMetaItem) {
      if (item.kind === 'mixed_media') {
        return item.id;
      }
      if (isStoryView) {
        return undefined;
      }
      return parentContentSubmissionId;
    }

    switch (direction) {
      case 'previous': {
        if (currentIndex === 0) {
          return '';
        }
        const previousItem = dataSource[currentIndex - 1];
        if (!previousItem) {
          return '';
        }

        const parentId = getParentId(previousItem);
        return getLink({
          parentContentSubmissionId: parentId,
          contentSubmissionId:
            previousItem.kind === 'mixed_media' ? undefined : previousItem.id,
        });
      }
      case 'next': {
        if (currentIndex + 1 === total) {
          return '';
        }
        const nextItem = dataSource[currentIndex + 1];
        if (!nextItem) {
          return '';
        }

        const parentId = getParentId(nextItem);
        return getLink({
          parentContentSubmissionId: parentId,
          contentSubmissionId:
            nextItem.kind === 'mixed_media' ? undefined : nextItem.id,
        });
      }
      default:
        return '';
    }
  };

  return {
    previousLink: buildLink('previous'),
    nextLink: buildLink('next'),
    current,
    total,
  };
}

export default useContentSubmissionNavigation;
